import MCButton from '@/components/ui/Buttons/MobicomButton'
import Link from 'next/link'
import React, { FunctionComponent } from 'react'
import useIntl from '@/utils/intl'
import { resolveImageUrl } from '@/utils/constants'
import Image from 'next/image'

const MobiAiBanner: FunctionComponent<{}> = () => {
  const { translate } = useIntl()
  return (
    <div className="w-full h-[450px] flex items-center justify-center mt-6">
      <div className="w-[95vw] h-full flex items-center justify-center rounded-[16px] overflow-hidden relative">
        <Image
          src={resolveImageUrl('/uploads/mobiAI_bg.png')}
          alt="branch"
          fill
          className="object-cover"
          draggable={false}
        />
        <div className="relative z-10 flex flex-col items-center justify-center gap-[10px]">
          <p className="text-[57px] font-[800] text-textAdditional">
            {translate('mobiai.header')}
          </p>

          <p className="text-textAdditional text-center">
            {translate('mobiai.subheader')}
          </p>

          <Link
            href="https://aistore.circles.life/ai-chatbox?tenant=mobicom"
            target="_blank"
          >
            <MCButton size="sm" classNames="mt-[14px]">
              {translate('mobiai.ask')}
            </MCButton>
          </Link>
        </div>
      </div>
    </div>

  )
}
export default MobiAiBanner
